import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { UserPlus, Flag, UserClock, Send } from 'assets/icons/components'
import {
  setIsOnCall, setLocalStream, setActiveConversation, setCurrentCallUser,
  setMainContent, setIsFullScreen, setRegisterModal, setToUser, setUpgradeModal,
  cancelFriendRequest
} from 'actions'
import { FriendServices, RealtimeServices } from 'services'

import { toast } from 'components/common/Toast'
import { Modal, Form, Button, Spinner } from 'react-bootstrap'
import { addConversation, setConversations } from 'actions/chat'
import { useTranslation } from 'react-i18next'
import i18n from 'config/i18n'
import { Avatar } from 'components/common'
import PerfectScrollbar from 'components/common/PerfectScrollbar/PerfectScrollbar'
import { RecentLineWrapperDiv, ReportModal } from 'components//common/index'
import { receiveFriendRequest } from 'actions/relationship'
import { MessageServices } from 'services/index'
import { setRecentUsers } from 'actions/videoCall'

const History = (props) => {
  const { t } = useTranslation('live', { i18n })
  const { user, dispatch, userStatus, conversations, recentUsers } = props
  const [isShowBlockModal, setIsShowBlockModal] = useState(false)
  const [askUser, setAskUser] = useState('')
  const [loading, setLoading] = useState(null)

  // useEffect(() => {
  //   if (!recentUsers) {
  //     getRecents()
  //   }
  // }, [])

  useEffect(() => {
    if (userStatus && recentUsers) {
      let allUsers = recentUsers.map(user => {

        if (user?.uid === userStatus?.uid) {
          user.online = userStatus?.online
        }

        return user
      })

      setRecentUsers(allUsers)
    }
  }, [userStatus])

  const addFriend = async (conversation) => {
    if (user?.account_tier === 0 && user?.gender === 0) {
      dispatch(setRegisterModal(true))
      return
    }

    setLoading(`add-${conversation?.uid}`)
    let { friend, error, exception } = await FriendServices.sendFriendRequest(conversation?.id)

    if (exception === 'REQUIRED_PREMIUM') {
      setLoading(null)
      dispatch(setUpgradeModal(true))
      return;
    }

    if (friend) {
      let allUsers = recentUsers.map((u) => {
        if (conversation?.uid === u?.uid) {
          u.relationship = friend.status
          u.relationship_id = friend.id
        }
        
        return u
      })

      dispatch(receiveFriendRequest(friend, null))
      dispatch(setRecentUsers(allUsers))

      toast.success(t('Friend request sent'))
    }
    if (error) {
      toast.error(error?.response?.data?.message)
    }
    setLoading(null)
  }

  const cancelFriend = async (conversation) => {
    setLoading(`cancel-${conversation?.uid}`)
    let { error } = await FriendServices.cancelFriendRequest(conversation?.relationship_id)
    
    if (error) {
    } else {
      toast.success(t('Friend request cancelled'))

      let allUsers = recentUsers.map((u) => {
        if (conversation?.uid === u?.uid) {
          u.relationship = null
          u.relationship_id = null
        }

        return u
      })

      dispatch(setRecentUsers(allUsers))
    }
    setLoading(null)
  }

  const startChat = async (user) => {
    const activeConversation = conversations.find(conversation => conversation?.participant?.uid === user?.uid)

    
    if (activeConversation) {
      dispatch(setMainContent('chat'))
      dispatch(setActiveConversation(activeConversation))
      dispatch(setIsFullScreen(false))
    } else {
      const { conversation } = await MessageServices.getConversation(user?.uid)

      if (conversation) {
        dispatch(setMainContent('chat'))
        dispatch(setActiveConversation(conversation))
        dispatch(setIsFullScreen(false))
        dispatch(addConversation(conversation))
      }
    }
  }

  const blockAsk = async (user) => {
    setAskUser(user)
    setIsShowBlockModal(true)
  }

  const handleCloseBlockModal = () => {
    setIsShowBlockModal(false)
    setTimeout(() => {
      setAskUser('')
    }, 200)
  }

  return (
    <div className='content__history'>
      <ReportModal
        show={isShowBlockModal}
        hide={handleCloseBlockModal}
        user={askUser}
      >
      </ReportModal>

      <PerfectScrollbar>
      { recentUsers && recentUsers.length 
        ?
        recentUsers.map((user, index) =>
          <RecentLineWrapperDiv className='history__user-wrapper' key={`user-${index}`}>
            <div className='user-wrapper__info'>
              <Avatar className='info__avatar' user={user} />
              <div className='info__username'>
                { user?.name }
              </div>
            </div>
            <div className='user-wrapper__actions'>
              {
                user?.role === 'user' && (!user?.relationship || user?.relationship === 'Cancelled')
                ?
                  <>
                    <div
                      className={`actions__icon ${loading === `add-${user?.uid}` ? 'actions__icon--loading' : ''}`}
                      onClick={() => loading === `add-${user?.uid}` ? '' : addFriend(user)}>
                      { loading === `add-${user?.uid}` 
                        ?
                          <Spinner animation='border' size='sm' />
                        : 
                          <UserPlus className="icon__icon" />
                      }
                    </div>
                    <div className='actions__icon actions__icon--danger' onClick={() => blockAsk(user)}>
                      <Flag className='icon__icon' />
                    </div>
                  </>
                : <></>
              }
              {user?.relationship === 'Pending' && (
                <>
                  <div
                    className={`actions__icon actions__icon--danger ${loading === `cancel-${user?.uid}` ? 'actions__icon--loading' : ''}`}
                    onClick={() => loading === `cancel-${user?.uid}` ? '' : cancelFriend(user)}>
                    { loading === `cancel-${user?.uid}` 
                      ?
                        <Spinner animation='border' size='sm' />
                      : 
                      <UserClock className="icon__icon" />
                    }
                  </div>
                  <div className='actions__icon actions__icon--danger' onClick={() => blockAsk(user)}>
                    {/* <Flag className='icon__icon' /> */}
                    <Flag className='icon__icon' />
                  </div>
                </>
              )}
              {user?.relationship === 'Accepted' && (
                <>
                  <div className='actions__icon actions__icon--active' onClick={() => startChat(user)}>
                  <Send className='icon__icon' />
                  </div>
                  <div className='actions__icon actions__icon--danger' onClick={() => blockAsk(user)}>
                    {/* <Flag className='icon__icon' /> */}
                    <Flag className='icon__icon' />
                  </div>
                </>
              )}
            </div>
          </RecentLineWrapperDiv>
        )
        :
        <div className='history__no-history'>
          {t('No recent history recorded')}
        </div>
      }
      </PerfectScrollbar>
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.connectionReducer.user,
  socket: state.connectionReducer.socket,
  isOnCall: state.videoCallReducer.isOnCall,
  localStream: state.videoCallReducer.localStream,
  userStatus: state.chatReducer.userStatus,
  conversations: state.chatReducer.conversations,
  recentUsers: state.videoCallReducer.recentUsers,
})

export default connect(mapStateToProps)(History)
